/* eslint-disable react/no-did-update-set-state */
import { Field, Form, withFormik } from "formik";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import Container from "pages/_components/Container";
import { connect } from "react-redux";
import { push } from "react-router-redux/actions";
import { compose } from "redux";

import { Button as ButtonSB } from "@ui-kit/components/index.es";
import classNames from "classnames";
import moment from "moment";
import Button from "pages/_components/Button";
import ContextMenu from "pages/_components/ContextMenu";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import { DateField } from "pages/_components/fields/DateField";
import TextField from "pages/_components/fields/TextField";
import Selector from "pages/_components/fields/formik/Selector";
import RangeDatePicker from "pages/_components/fields/rangedatepicker/RangeDatePicker";
import { resizableRoute } from "pages/_components/Resizable";
import IncomingDebinTable from "pages/debinPayments/_components/IncomingDebinTable";
import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as debinActions, selectors as debinSelectors, INITIAL_STATE } from "reducers/debin";
import { selectors as sessionSelectors } from "reducers/session";
import * as configUtils from "util/config";
import { buildAddLimitRequestLocation } from "util/addLimitRequestNavigation";
import { allStatus } from "util/debin";
import { evalEqualsValues } from "util/form";
import * as i18n from "util/i18n";
import { saveLocation } from "util/transaction";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";
import Yup from "yup";

const FORM_ID = "debinPayments.incomingDebin.list";

class IncomingDebinList extends Component {
    state = {
        selectedDateFrom: null,
        selectedDateTo: null,
        showForm: false,
        hasChanged: false,
    };

    static propTypes = {
        accounts: arrayOf(shape({})).isRequired,
        activeEnvironment: shape({
            permissions: shape({
                debinRecurrency: bool,
            }),
        }).isRequired,
        dateFrom: shape({}).isRequired,
        dateTo: shape({}).isRequired,
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        filtersIncomingDebins: shape({
            dateFrom: shape({}).isRequired,
            dateTo: shape({}).isRequired,
            status: string.isRequired,
            recipient: string.isRequired,
        }).isRequired,
        isDesktop: bool.isRequired,
        embeddedInV3Shell: bool,
        loggedUser: shape({}).isRequired,
        setFieldValue: func.isRequired,
        values: shape({}).isRequired,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    componentDidMount() {
        const { dispatch, setFieldValue, filtersIncomingDebins, accounts, loggedUser, values } = this.props;
        const { status, dateFrom, dateTo, recipient } = filtersIncomingDebins;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        saveLocation(this.props);
        this.setState({
            hasChanged: !evalEqualsValues(
                INITIAL_STATE.filtersIncomingDebins,
                values,
                [
                    "pageNumber",
                    ...(!enableRangeDatefield ? ["dates"] : []),
                    ...(enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                ],
                [...(enableRangeDatefield ? ["dates"] : []), ...(!enableRangeDatefield ? ["dateFrom", "dateTo"] : [])],
            ),
        });
        this.setState({ selectedDateFrom: dateFrom });
        this.setState({ selectedDateTo: dateTo });
        setFieldValue("dateFrom", dateFrom);
        setFieldValue("dateTo", dateTo);
        setFieldValue("dates", [dateFrom, dateTo]);
        if (accounts.length === 0) {
            dispatch(accountsActions.listAccounts(loggedUser.userId));
        }
        dispatch(debinActions.loadIncomingRequests({ status, dateFrom, dateTo, recipient, pageNumber: 1 }));
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, activeEnvironment } = this.props;
        const permissionsChanged = prevProps.activeEnvironment?.permissions !== activeEnvironment?.permissions;
        if (
            embeddedInV3Shell &&
            (prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
                prevProps.isDesktop !== isDesktop ||
                permissionsChanged)
        ) {
            this.syncEmbeddedV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop } = this.props;
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["debin"],
            titleKey: "debinPayments.incomingDebin.list.title",
            goBackPath: "/v3/dashboard",
            rightContentMobile: !isDesktop ? this.getMobileIncomingDebinListContextMenu() : undefined,
        });
    };

    getMobileIncomingDebinListContextMenu = () => {
        const { dispatch, activeEnvironment } = this.props;
        if (!activeEnvironment.permissions.debinRecurrency) {
            return null;
        }
        const useApiV3 = configUtils.getBoolean("frontend.show.RecurringDebin.functionalities", false);
        const programedDebinEnabled = configUtils.getBoolean("frontend.show.programedDebin.enable", false);
        const showProgrammedBtn = programedDebinEnabled && activeEnvironment.permissions.debinRecurrencyProgrammed;
        const showtemporarilyincreaselimit = configUtils.getBoolean(
            "frontend.temporarilyincreaselimit.functionalities",
        );

        const items = [
            ...(showtemporarilyincreaselimit
                ? [
                      {
                          label: "addLimitRequest.label",
                          onClick: () => dispatch(push(buildAddLimitRequestLocation("/payments/payDebin"))),
                          icon: "AddLimit",
                      },
                  ]
                : []),
            {
                label: `debinPayments.incomingDebin.buyerRecurrences.button${useApiV3 ? "V3" : ""}`,
                onClick: () => dispatch(push("/payments/recurrent")),
                icon: "Sync",
            },
        ];
        if (showProgrammedBtn) {
            items.unshift({
                label: "debinPayments.incomingDebin.programed.button",
                onClick: () => dispatch(push("/v2/debin/scheduled")),
                icon: "Sync",
            });
        }

        return (
            <ContextMenu
                isDesktop={false}
                color="white"
                buttonClassName="align-self-center account-dropdown-header-font font-black-alpha"
                items={items}
            />
        );
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            dispatch(push("/v3/dashboard"));
            return;
        }
        dispatch(push("/desktop/"));
    };

    rightContent = () => {
        const { dispatch, isDesktop, activeEnvironment } = this.props;
        if (!activeEnvironment.permissions.debinRecurrency) {
            return null;
        }
        const useApiV3 = configUtils.getBoolean("frontend.show.RecurringDebin.functionalities", false);
        const programedDebinEnabled = configUtils.getBoolean("frontend.show.programedDebin.enable", false);
        const showProgrammedBtn = programedDebinEnabled && activeEnvironment.permissions.debinRecurrencyProgrammed;
        const showtemporarilyincreaselimit = configUtils.getBoolean(
            "frontend.temporarilyincreaselimit.functionalities",
        );
        if (isDesktop) {
            return (
                <>
                    <div className="d-flex align-items-center justify-content-end" style={{ gap: "16px" }}>
                        {showtemporarilyincreaselimit && (
                            <ButtonSB
                                justify="right"
                                text={i18n.get("addLimitRequest.label")}
                                variant="solid"
                                icon="AddLimit"
                                iconVariant="outline"
                                onClick={() => {
                                    dispatch(push(buildAddLimitRequestLocation("/payments/payDebin")));
                                }}
                            />
                        )}
                        {showProgrammedBtn && (
                            <Button
                                className="btn-outline mr-0"
                                block
                                onClick={() => dispatch(push("/v2/debin/scheduled"))}
                                label="debinPayments.incomingDebin.programed.button"
                            />
                        )}
                        <Button
                            className="btn-outline"
                            block
                            onClick={() => dispatch(push("/payments/recurrent"))}
                            label={`debinPayments.incomingDebin.buyerRecurrences.button${useApiV3 ? "V3" : ""}`}
                        />
                    </div>
                </>
            );
        }

        return this.getMobileIncomingDebinListContextMenu();
    };

    renderEmptyState = () => {};

    handleChangeDateFrom = (selectedDate) => {
        this.setState({ selectedDateFrom: selectedDate });
    };

    getMinDateFrom = () => {
        const daysBefore = configUtils.getInteger("frontend.debin.requests.min.dateFrom", 180);
        return moment().add(-daysBefore, "days");
    };

    handleChangeDateTo = (selectedDate) => {
        this.setState({ selectedDateTo: selectedDate });
    };

    getPreviousDate = (days) => {
        const currentDate = new Date();
        const myPastDate = new Date(currentDate);
        myPastDate.setDate(myPastDate.getDate() - days);
        return myPastDate;
    };

    centerContentMobile = () => (
        <div>
            <h1 className="m-0">{i18n.get("debinPayments.incomingDebin.list.title")}</h1>
        </div>
    );

    clearFilters = () => {
        const { setFieldValue, dispatch } = this.props;

        const dateFrom = moment()
            .add(-1, "weeks")
            .toDate();
        const dateTo = moment().toDate();

        setFieldValue("recipient", "");
        setFieldValue("status", "INICIADO");
        setFieldValue("dateFrom", dateFrom);
        setFieldValue("dateTo", dateTo);
        setFieldValue("dates", [dateFrom, dateTo]);

        this.setState((prevState) => ({ ...prevState, hasChanged: false }));

        dispatch(
            debinActions.loadIncomingRequests({
                status: "INICIADO",
                dateFrom,
                dateTo,
                recipient: "",
                pageNumber: 1,
            }),
        );
    };

    handleFilterButton = () => {
        const { values } = this.props;
        const { recipient, status, dateFrom, dateTo, dates } = values;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const dateFromValue = enableRangeDatefield ? dates[0] : dateFrom;
        const dateToValue = enableRangeDatefield ? dates[1] : dateTo;
        if (dateFromValue && dateToValue) {
            const usingDefaultValues =
                moment()
                    .add(-1, "weeks")
                    .toDate()
                    .toDateString() === dateFromValue.toDateString() &&
                moment()
                    .toDate()
                    .toDateString() === dateToValue.toDateString() &&
                status === "INICIADO" &&
                !recipient;

            this.setState((prevState) => ({ ...prevState, hasChanged: !usingDefaultValues }));
        }
    };

    render() {
        const { fetching, isDesktop, embeddedInV3Shell, values, filtersIncomingDebins } = this.props;
        const { dateFrom, dateTo } = values;
        const { selectedDateFrom, selectedDateTo, showForm, hasChanged } = this.state;
        const defaultOptionStatus = { value: "Todos", label: "Todos" };
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        return (
            <>
                {!embeddedInV3Shell && <Notification scopeToShow="debin" />}
                {(!embeddedInV3Shell || isDesktop) && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleBack}
                            headerClassName={classNames({ "blue-main-header-mobile": !isDesktop })}
                            centerElement={isDesktop ? null : this.centerContentMobile}
                            centerContentClassName={classNames({ "mx-6 align-center": !isDesktop })}
                            rightContent={!isDesktop && this.rightContent}
                        />
                        {isDesktop && (
                            <>
                                <Head
                                    title="debinPayments.incomingDebin.list.title"
                                    rightContent={this.rightContent}
                                    centerContentClassName="p-0"
                                    nodeMessage={
                                        <I18n
                                            id=""
                                            defaultValue={configUtils.get("DEBIN.requestreceived.text")}
                                            component="p"
                                            componentProps={{ className: "hint-text hint-text-header max-width-22rem" }}
                                        />
                                    }
                                    alwaysShowMessage
                                />
                            </>
                        )}
                    </div>
                )}
                <PageLoading loading={fetching && isDesktop}>
                    <div className="above-the-fold">
                        <Form autocomplete="off" className="above-the-fold">
                            {isDesktop && (
                                <div className="mx-3">
                                    <Col className="hide-filter__btn-content mt-5">
                                        <Button
                                            block
                                            bsStyle="outline"
                                            className="hide-filter__btn m-0"
                                            label={
                                                showForm
                                                    ? "global.hide.filter"
                                                    : `${hasChanged ? "global.filter.active" : "global.see.filter"}`
                                            }
                                            image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                            onClick={() =>
                                                this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))
                                            }
                                        />
                                        {hasChanged && (
                                            <Button
                                                label="echeq.clean.filters"
                                                className="hide-filter__clean-btn"
                                                onClick={() => this.clearFilters()}
                                                image="images/cross.svg"
                                                imageStyle="circle-cross"
                                            />
                                        )}
                                    </Col>
                                </div>
                            )}
                            {!isDesktop && (
                                <Col xs={12} className="d-flex justify-content-end pr-0 py-3">
                                    <div className="hide-filter__btn-content">
                                        <Button
                                            block
                                            bsStyle="outline"
                                            className="hide-filter__btn m-0"
                                            label={
                                                showForm
                                                    ? "global.hide.filter"
                                                    : `${hasChanged ? "global.filter.active" : "global.see.filter"}`
                                            }
                                            image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                            onClick={() =>
                                                this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))
                                            }
                                        />
                                    </div>
                                    {hasChanged && (
                                        <Button
                                            label="global.clean.filters"
                                            className="clean-filters-label font-light p-absolute top-25 mt-2 pt-1 min-height-auto mr-4 "
                                            onClick={() => this.clearFilters()}
                                            image="images/cross.svg"
                                            imageStyle="circle-cross"
                                        />
                                    )}
                                </Col>
                            )}
                            {showForm && (
                                <Container
                                    className={`flex-grow ${
                                        isDesktop ? "container-white pt-3 mb-0 pb-2 px-3" : "px-2"
                                    }`}>
                                    <Col xs={12} md={6} lg={3}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            name="recipient"
                                            type="text"
                                            pattern="[0-9]*"
                                            maxLength={configUtils.get("cuit.validation.character.amount")}
                                            minLength={0}
                                            controlLabelClassName="text-transform-none"
                                        />
                                    </Col>
                                    <Col xs={12} md={6} lg={3}>
                                        <Field
                                            component={Selector}
                                            options={[defaultOptionStatus, ...allStatus]}
                                            idForm={FORM_ID}
                                            name="status"
                                            isRequired
                                            className="debin-select"
                                            searchable={isDesktop}
                                            controlLabelClassName="text-transform-none"
                                        />
                                    </Col>
                                    {enableRangeDatefield ? (
                                        <Col xs={12} md={8} lg={4} className="pt-1">
                                            <Field
                                                component={RangeDatePicker}
                                                idForm={FORM_ID}
                                                name="dates"
                                                maxDate={new Date()}
                                                minDate={this.getMinDateFrom().toDate()}
                                                required
                                            />
                                        </Col>
                                    ) : (
                                        <>
                                            <Col xs={12} md={4} lg={2}>
                                                <Field
                                                    idField="dateFrom"
                                                    component={DateField}
                                                    endDate={dateTo}
                                                    idForm={FORM_ID}
                                                    name="dateFrom"
                                                    hidePlaceholder
                                                    selectsStart
                                                    startDate={dateFrom}
                                                    handleChange={this.handleChangeDateFrom}
                                                    maxDate={selectedDateTo}
                                                    minDate={this.getMinDateFrom()}
                                                    controlLabelClassName="text-transform-none"
                                                />
                                            </Col>
                                            <Col xs={12} md={4} lg={2}>
                                                <Field
                                                    idField="dateTo"
                                                    component={DateField}
                                                    endDate={dateTo}
                                                    hidePlaceholder
                                                    idForm={FORM_ID}
                                                    name="dateTo"
                                                    selectsEnd
                                                    startDate={dateFrom}
                                                    minDate={selectedDateFrom}
                                                    isClearable={false}
                                                    handleChange={this.handleChangeDateTo}
                                                    maxDate={new Date()}
                                                    controlLabelClassName="text-transform-none"
                                                />
                                            </Col>
                                        </>
                                    )}
                                    <Col xs={12} md={4} lg={2}>
                                        <div className="form-group mt-4">
                                            <Button
                                                label={
                                                    enableNewSubmitButton
                                                        ? "global.filter"
                                                        : "debinPayments.incomingDebin.list.button.search"
                                                }
                                                bsStyle="primary"
                                                type="submit"
                                                className={classNames("mt-25 py-25", {
                                                    "text-transform-none min-height-btn": enableNewSubmitButton,
                                                })}
                                                onClick={() => this.handleFilterButton()}
                                                image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                                                imageStyle="mr-2"
                                                disabled={
                                                    enableNewSubmitButton &&
                                                    evalEqualsValues(
                                                        filtersIncomingDebins,
                                                        values,
                                                        [
                                                            "pageNumber",
                                                            ...(!enableRangeDatefield ? ["dates"] : []),
                                                            ...(enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                                        ],
                                                        [
                                                            ...(enableRangeDatefield ? ["dates"] : []),
                                                            ...(!enableRangeDatefield ? ["dateFrom", "dateTo"] : []),
                                                        ],
                                                    )
                                                }
                                            />
                                        </div>
                                    </Col>
                                </Container>
                            )}
                            <PageLoading className="line-loader" loading={fetching && isDesktop}>
                                <IncomingDebinTable isDesktop={isDesktop} />
                            </PageLoading>
                        </Form>
                    </div>
                </PageLoading>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUser: sessionSelectors.getUser(state),
    sentRequests: debinSelectors.getSentRequests(state),
    fetching: debinSelectors.getFetching(state),
    accounts: accountsSelectors.getAccounts(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    filtersIncomingDebins: debinSelectors.getFiltersIncomingDebins(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: false,
        validateOnBlur: false,
        mapPropsToValues: ({ filtersIncomingDebins }) => filtersIncomingDebins,
        validationSchema: () => {
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            return Yup.object().shape({
                recipient: Yup.string()
                    .nullable()
                    .min(
                        configUtils.get("cuit.validation.character.amount"),
                        i18n.get(`charges.debin.sentRequests.recipient.invalid`),
                    )
                    .max(
                        configUtils.get("cuit.validation.character.amount"),
                        i18n.get(`charges.debin.sentRequests.recipient.invalid`),
                    ),
                dateTo: Yup.string()
                    .nullable()
                    .required(i18n.get(`${FORM_ID}.field.error.required`)),
                dateFrom: Yup.string()
                    .nullable()
                    .required(i18n.get(`${FORM_ID}.field.error.required`)),
                ...(enableRangeDatefield && {
                    dates: Yup.mixed().test(
                        "dates",
                        i18n.get(`${FORM_ID}.validation.range.date`),
                        ([from, to]) => from && to,
                    ),
                }),
            });
        },
        handleSubmit: (values, formikBag) => {
            const { dispatch } = formikBag.props;
            const { status, dateFrom, dateTo, dates, recipient } = values;
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

            dispatch(
                debinActions.loadIncomingRequests({
                    status,
                    dateFrom: enableRangeDatefield ? dates[0] : dateFrom,
                    dateTo: enableRangeDatefield ? dates[1] : dateTo,
                    recipient,
                    pageNumber: 1,
                }),
            );
        },
    }),
    resizableRoute,
)(IncomingDebinList);
